import AppActions from './actions-types'
import AppMutations from './mutations-types'

import api from '@/services/api'
import notification from '@/services/notification'

// Tracks an in-flight applications fetch so concurrent callers (e.g. the
// router guard and SAVE_LOGIN_DATA firing at the same time) share a single
// request and all resolve only after the store has been populated.
let userApplicationsPromise = null

export default {

  [AppActions.OPEN_APP_ERROR_MESSAGE]({ commit }, message) {
    commit(AppMutations.SET_APP_MESSAGE_TEXT, message)
    commit(AppMutations.SET_APP_MESSAGE_TYPE, 'error')
    commit(AppMutations.SET_APP_MESSAGE_OPEN, true)
  },

  [AppActions.OPEN_APP_SUCCESS_MESSAGE]({ commit }, message) {
    commit(AppMutations.SET_APP_MESSAGE_TEXT, message)
    commit(AppMutations.SET_APP_MESSAGE_TYPE, 'success')
    commit(AppMutations.SET_APP_MESSAGE_OPEN, true)
  },

  [AppActions.OPEN_APP_INFO_MESSAGE]({ commit }, message) {
    commit(AppMutations.SET_APP_MESSAGE_TEXT, message)
    commit(AppMutations.SET_APP_MESSAGE_TYPE, 'info')
    commit(AppMutations.SET_APP_MESSAGE_OPEN, true)
  },

  [AppActions.GET_AND_SET_USER_APPLICATIONS]({ commit, state }) {
    // Avoid refetching if already loaded
    if (Array.isArray(state.userApplications) && state.userApplications.length > 0) {
      return Promise.resolve({ items: state.userApplications })
    }

    // Share a single request among concurrent callers. Without this, the
    // router guard and SAVE_LOGIN_DATA can each start their own fetch; the
    // first to resolve lets the guard proceed while the store might not yet
    // be committed, leading to an empty userApplications check and a spurious
    // redirect to the home page.
    if (userApplicationsPromise) {
      return userApplicationsPromise
    }

    userApplicationsPromise = api.core.application_instance
      .getUserAppInstances()
      .then((response) => {
        commit(AppMutations.SET_USER_APPLICATIONS, response.data.items)
        commit(AppMutations.SET_USER_MENU_ITEMS, response.data.items)

        return response.data
      })
      .finally(() => {
        userApplicationsPromise = null
      })

    return userApplicationsPromise
  },


  [AppActions.SET_CONTENT_PERSONAL_PREFERENCE]({ commit }, params) {
    commit(AppMutations.UPDATE_CONTENT_PERSONAL_PREFERENCE, params)
  },

  [AppActions.CONNECT_WEBSOCKET]({ commit }) {
    const socket = notification.connect()
    commit(AppMutations.SET_SOCKET, socket)
  },

  [AppActions.DISCONNECT_WEBSOCKET]({ commit, state }) {
    state.socket.disconnect()
    commit(AppMutations.SET_SOCKET, null)
  },

  [AppActions.SUBSCRIBE_TO_ROOM]({ state }, room) {
    if (!state.socket || room === null || room === undefined) {
      return
    }

    state.socket.emit('subscribe', room)
  },

  [AppActions.UNSUBSCRIBE_FROM_ROOM]({ state }, room) {
    if (!state.socket || room === null || room === undefined) {
      return
    }

    state.socket.emit('unsubscribe', room)
  },

  [AppActions.SET_LOCALE]({ commit }, locale) {
    commit(AppMutations.SET_LOCALE, locale)
  }
}
